<template>
    <MapMobile class="animated fadeIn" :gestureHandling="false" />
</template>

<script>
import MapMobile from '@/components/MapMobile';

export default {
    components: {
        MapMobile
    }
};
</script>
